import React from 'react'
import { Switch } from 'react-router-dom'
import AclRoute from 'src/components/Router/AclRoute'
import Loadable from 'src/utils/loadable'

const routes = () => {
  return (
    <Switch>
      <AclRoute
        path='/payments/insurances'
        component={Loadable(() => import('./Insurances'))}
        isPrivate
      />
      <AclRoute
        path='/payments/e-transfer'
        component={Loadable(() => import('./ETransferInstructions'))}
        isPrivate
      />
      <AclRoute path='/payments/e-pay' component={Loadable(() => import('./EPay'))} />
      <AclRoute path='/payments/u' component={Loadable(() => import('./Policies'))} isPrivate />
      <AclRoute path='/payments' component={Loadable(() => import('./Redirect'))} />
    </Switch>
  )
}

export default routes
